module.exports = __webpack_public_path__ + "media/images/athletes/202-61d57778b15adc00e3ba7e7c39fed1b8.png";